const QTYPE_TEXT = 1, QTYPE_IMAGE = 2, QTYPE_AUDIO = 3, QTYPE_VIDEO = 4, QTYPE_FREE_TEXT = 5, QTYPE_MULTIPLE_IMAGE = 6, QTYPE_HOT_SPOT = 7;

class QuestionUtils
{
    static isTextQuestion(question) {
        return (question && question.qtype == QTYPE_TEXT);
    }
    static isImageQuestion(question) {
        return (question && question.qtype == QTYPE_IMAGE);
    }
    static isMultipleImageQuestion(question) {
        return (question && question.qtype == QTYPE_MULTIPLE_IMAGE);
    }
    static isFreeTextQuestion(question) {
        return (question && question.qtype == QTYPE_FREE_TEXT);
    }
    static isHotSpotQuestion(question) {
                return (question && question.qtype == QTYPE_HOT_SPOT);
    }
    static isAudioQuestion(question) {
        return (question && question.qtype == QTYPE_AUDIO);
    }
    static isVideoQuestion(question) {
        return (question && question.qtype == QTYPE_VIDEO);
    }
    static isMultimediaQuestion(question) {
        return (question && (
                question.qtype == QTYPE_IMAGE ||
                question.qtype == QTYPE_AUDIO ||
                question.qtype == QTYPE_VIDEO ||
                question.qtype == QTYPE_MULTIPLE_IMAGE ||
                question.qtype == QTYPE_HOT_SPOT ||
                question.qtype == QTYPE_FREE_TEXT
            ));
    }
}
